// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1h-0";
export var spinnerContainer = "_1h-1";